var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapNativeSuper");

module.exports = /*#__PURE__*/function (_Error) {
  "use strict";

  _inherits(AbortError, _Error);

  var _super = _createSuper(AbortError);

  function AbortError(message, code) {
    var _this;

    _classCallCheck(this, AbortError);

    _this = _super.call(this, message || 'The operation was aborted');
    _this.type = 'aborted';
    _this.code = code || 'ABORT_ERR';
    return _this;
  }

  return AbortError;
}( /*#__PURE__*/_wrapNativeSuper(Error));